module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.info.title))]), _vm._v(" "), _c('div', {
    staticClass: "logos"
  }, _vm._l((_vm.info.logo), function(item, i) {
    return _c('img', {
      key: i,
      attrs: {
        "src": item
      }
    })
  }), 0), _vm._v(" "), (_vm.info.progress < 100) ? _c('div', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.info.text1))]) : _c('div', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.info.text3))]), _vm._v(" "), (_vm.info.progress < 100) ? [_c('video', {
    attrs: {
      "src": _vm.info.video,
      "poster": _vm.info.poster,
      "controls": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "progress1"
  }, [_c('span', [_vm._v("当前进度"), _c('label', [_vm._v(_vm._s(_vm.info.progress) + "%")])]), _vm._v(" "), _c('label', [_vm._v("更新于" + _vm._s(_vm.info.update_time))])]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "fill",
    style: ({
      width: _vm.info.progress + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.info.text2))]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "submit"
  }, [_vm._v(_vm._s(_vm.info.button_text))])])] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4eb19914","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pay/index.vue
// module id = 323
// module chunks = 0